module.exports = __webpack_public_path__ + "img/icon-lottery-white.29d20e1b.svg";